<template>
  <div class="ab-report heatmap-report content padding_both_sides"
       ref="scrollContent"
       :class="{'layout__ab-heatmap': isHeatmapReport}">
    <div class="ab-report-content__header">
      <h2>
        <ui-button
          circle
          iconName="icon--inflow__back"
          @click.prevent="$router.push({ name: 'ab.list', params: { aid: $route.params.aid } })">
        </ui-button>
        <span>{{ $t('ab.report.title') }}</span>
        <span class="ab-report-header--text">
          <span class="division" />
          <span>{{ $t('ab.report.sub.' + bData.abTestType) }}</span>
          <ui-button :iconName="'icon--ab--check-edit'" @click="showEditPopup = true" v-if="bData.abTestType !== 'url'">{{ $t('ab.checkEdit') }}</ui-button>
        </span>
      </h2>
    </div>
    <ul class="ab-report-content__nav">
      <li @click="onReportTypeChange('default')" :class="{on: !isHeatmapReport}">
        {{ $t('ab.report.nav.default') }}
      </li>
      <li @click="onReportTypeChange('heatmap')" :class="{on: isHeatmapReport}">
        {{ $t('ab.report.nav.heatmap') }}
      </li>
      <li class="sync" v-if="isHeatmapReport">
        <span>{{ $t('heatmap.sync') }}</span>
        <ui-switch v-model="heatmapSync"/>
      </li>
      <li class="edit" v-if="isHeatmapReport && bData.abTestType === 'text'">
        <span>{{ $t('heatmap.edit') }}</span>
        <ui-switch v-model="editStatus"/>
      </li>
      <li class="heatmap__control_guide" v-if="isHeatmapReport">
        <span>{{$t('common.guide.title')}}</span>
        <a :href="goLink" target="_blank">{{$t('common.guide.more')}}</a>
        <i class="icon icon--bc-step"></i>
      </li>
    </ul>
    <div v-if="hasData" class="ab-report-content--wrap">
      <ab-report-default v-if="isDefaultReport"
        :abList="abList"
        :aData="aData"
        :bData="bData"
        :abTestType="bData.abTestType">
        <back-to-top refName="scrollContent"/>
      </ab-report-default>
      <ab-report-heatmap v-else
        class="content__heatmap"
        :isSynced="heatmapSync"
        :aid="abAid"
        :aData="aData"
        :bData="bData"
        :isEditStatus="editStatus" />
    </div>
    <div class="popup" v-if="showEditPopup">
      <a-b-report-text-edit-popup @closePopup="showEditPopup = false" :editData="editData"/>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { getDialog } from '@/libs/vue-utils'
import abReportDefault from '@/components/report-ab/ABreportDefault'
import abReportHeatmap from '@/components/report-ab/ABreportHeatmap'
import ABReportTextEditPopup from '@/components/report-ab/ABReportTextEditPopup'
import UiSwitch from '@/components/ui/UiSwitch'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import { getTextList } from '../../../../api/abtest'

const openDialog = getDialog('dialogType')

export default {
  name: 'ABView',
  components: {
    abReportDefault,
    abReportHeatmap,
    ABReportTextEditPopup,
    UiSwitch,
    BackToTop,
    UiButton
  },
  data () {
    return {
      hasData: false,
      heatmapSync: false,
      showEditPopup: false,
      editStatus: false,
      editData: []
    }
  },
  computed: {
    ...mapState([
      'abList',
      'applyData'
    ]),
    abAid () {
      return this.$route.params.abAid
    },
    aData () {
      return this.applyData
    },
    bData () {
      return this.abList.find(item => item.aid === this.abAid)
    },
    viewType () {
      return this.$route.params.viewType
    },
    isHeatmapReport () {
      return this.viewType === 'heatmap'
    },
    isDefaultReport () {
      return !this.isHeatmapReport
    },
    goLink () {
      const lang = this.$i18n.locale

      if (lang === 'en') {
        return 'https://forum.beusable.net/en/solomon/post/1859'
      } else if (lang === 'ja') {
        return 'https://forum.beusable.net/ja/solomon/post/1858'
      } else {
        return 'https://forum.beusable.net/ko/solomon/post/1857'
      }
    }
  },
  created () {
    if (!this.aData || !this.bData) {
      openDialog('common.error').then(() => {
        const aid = this.$route.params.aid
        this.$router.replace({ name: 'ab.list', params: { aid } })
      })
    } else {
      this.hasData = true
      this.setABPageName(this.bData.pageName)
    }

    if (this.bData.abTestType === 'text') {
      getTextList({
        orgAid: this.$route.params.aid,
        aid: this.bData.aid
      }).then((result) => {
        result.forEach((v) => {
          v.openHtml = false
        })
        this.editData = result
      })
    }
  },
  destroyed () {
    this.setABPageName(null)
  },
  methods: {
    ...mapMutations([
      'setABPageName'
    ]),
    onReportTypeChange (viewType) {
      const params = this.$route.params

      if (viewType === 'default') {
        delete params.viewType
      } else {
        params.viewType = 'heatmap'
      }
      this.$router.replace({
        name: this.$route.name,
        params: params
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ab-report {
  overflow-y: auto;
  padding-bottom: 85px;
  position: relative;

  &.layout__ab-heatmap {
    padding-bottom: 0;

    .ab-report-content--wrap {
      height: calc(100% - 129px);
      .content__heatmap {
        height: 100%;
        padding-right: 30px;
      }
    }
  }

  .ab-report-content__header {
    margin-top: 30px;
    h2 {
      font-size: 22px;
      font-weight: bold;
      color: #444444;

      .ui-btn {
        margin-right: 15px;
        height: 38px;

        span {
          top: -1px !important;
          font-size: 13px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1;
          letter-spacing: normal;
          text-align: center;
          color: #444;
        }
      }

      .ui-btn,
      span {
        vertical-align: middle;
      }
    }
  }

  .ab-report-header--text {
    display: inline-flex;
    align-items: center;
    column-gap: 10px;

    margin-left: 10px;

    .division {
      width: 1px;
      height: 12px;
      background-color: #d7d7d7;
    }

    span {
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      color: #444;
    }
  }

  .ab-report-content__nav {
    display: flex;
    align-items: center;
    margin-top: 30px;
    li {
      display: inline-block;
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      color: #999999;
      cursor: pointer;
      padding-bottom: 8px;
      box-sizing: border-box;

      &.on {
        color: #2f2f2f;
        border-bottom: 3px solid $brandColor;
      }

      &.sync {
        position: relative;
        padding-left: 15px;
        margin-left: 15px;
        font-size: 12px;
        color: #666;
        cursor: default;

        &:before {
          display: inline-block;
          content: '';
          width: 1px;
          height: 12px;
          border-left: 1px solid #d7d7d7;
          position: absolute;
          top: 0;
          left: 0;
        }

        button {
          position: absolute;
          top: -7px;
          left: calc(100% + 10px);
          width: 53px;
          height: 25px;
          border-radius: 12.5px;
          font-size: 12px;
          font-weight: bold;
          box-sizing: border-box;
          background-color: #d7d7d7;
          color: #fff;
          text-align: right;
          padding-right: 7px;

          &.on {
            background-color: #64b950;
            text-align: left;
            padding-left: 7px;

            .circle {
              left: auto;
              right: 3px;
            }
          }

          .circle {
            display: inline-block;
            width: 18px;
            height: 18px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
            background-color: #ffffff;
            border-radius: 50%;
            @include positionYcenter;
            left: 3px;
          }
        }
      }

      &.edit {
        position: relative;
        padding-left: 15px;
        margin-left: 65px;
        font-size: 12px;
        color: #666;
        cursor: default;

        button {
          position: absolute;
          top: -7px;
          left: calc(100% + 10px);
          width: 53px;
          height: 25px;
          border-radius: 12.5px;
          font-size: 12px;
          font-weight: bold;
          box-sizing: border-box;
          background-color: #d7d7d7;
          color: #fff;
          text-align: right;
          padding-right: 7px;

          &.on {
            background-color: #64b950;
            text-align: left;
            padding-left: 7px;

            .circle {
              left: auto;
              right: 3px;
            }
          }

          .circle {
            display: inline-block;
            width: 18px;
            height: 18px;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
            background-color: #ffffff;
            border-radius: 50%;
            @include positionYcenter;
            left: 3px;
          }
        }
      }

      &:first-child {
        margin-right: 38px;
      }

      &.heatmap__control_guide {
        display: flex;
        align-items: center;
        margin-left: 63px;
        cursor: initial;

        &::before {
          content: '';
          display: inline-block;
          width: 1px;
          height: 12px;
          background: #D7D7D7;
          margin: 0 16px;
        }

        > span, a {
          color: #767676;
          font-family: Roboto;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 12px; /* 100% */
        }

        > span {
          margin-right: 8px;
        }

        > a {
          cursor: pointer;
        }

        > .icon.icon--bc-step {
          width: 14px;
          height: 14px;
          padding: 0;
          background-position: 0px center;
        }
      }
    }
  }
  .ab-report-content--wrap {
    margin-top: 21px;
  }
}
.popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}
</style>
